import { render, staticRenderFns } from "./demensionTable.vue?vue&type=template&id=da20b25a&scoped=true&"
import script from "./demensionTable.vue?vue&type=script&lang=js&"
export * from "./demensionTable.vue?vue&type=script&lang=js&"
import style0 from "./demensionTable.vue?vue&type=style&index=0&id=da20b25a&prod&lang=less&rel=stylesheet%2Fless&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da20b25a",
  null
  
)

export default component.exports